import React from "react";
import {Form, Switch} from "antd";
import IEntityTableOptions from "../../../../../../model/interface/form/elementOptions/IEntityTableOptions";
import {RELATION_FIELD_TYPE} from "../../../../../../model/interface/dataStorage/IField";
import FieldPicker from "../../../../../shared/pickers/FieldPicker";
import IContentType from "../../../../../../model/interface/dataStorage/IContentType";
import LocaleText from "../../../../settings/dictionary/LocaleText";

interface IProps {
    options: IEntityTableOptions
    contentType: IContentType
}

class EntityTableEditor extends React.Component<IProps, IEntityTableOptions> {

    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        this.state = {
            ...props.options
        }
    }

    render() {
        let {contentType} = this.props

        return (
            <div>
                <Form.Item name={'fieldId'} label={'Podminene pole'} rules={[{required: true}]}>
                    <FieldPicker serviceClassName={contentType.fullClassName} allowTypes={[
                        RELATION_FIELD_TYPE.ONE_TO_MANY,
                        RELATION_FIELD_TYPE.MANY_TO_MANY
                    ]} output={'uuid'}/>
                </Form.Item>
                <Form.Item name={'add'} label={'Moznost vytvorit'} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item name={'delete'} label={'Moznost mazat'} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item name={'required'} label={<LocaleText code={'configuration.form.entity-table.required'} fallback={'Pole je povinne'}/>} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
            </div>
        )
    }
}

export default EntityTableEditor